 
<template>
  <div>
    <j-select-biz-component :width="1000" ref="bizModal" returnId v-bind="configs" v-on="$listeners">
      <a-button @click="handleAdd" class="ml-8px" icon="plus" slot="action" type="primary" v-if="openCreate">新增</a-button>
    </j-select-biz-component>
    <dev-model-modal @ok="modalFormOk" ref="modalForm"></dev-model-modal>
  </div>
</template>

<script>
  import JSelectBizComponent from './JSelectBizComponent'
  import DevModelModal from '@/views/equipment/account/vue/modules/DevModelModal'

  export default {
    name: 'JSelectDeviceMode',
    components: { JSelectBizComponent, DevModelModal },
    props: {
      value: {
        type: String,
        default: ''
      },
      settings: {
        type: Object,
        default: () => { }
      },
      openCreate: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {

      }
    },
    created () {

    },
    computed: {
      configs () {
        return Object.assign({ value: this.value }, this.settings, this.$attrs)
      }
    },
    created () {

    },
    methods: {
      modalFormOk (id = '') {
        this.$emit('modeAddEnd', id)
        this.$refs.bizModal.visible = false
      },
      handleAdd: function () {
        this.$refs.modalForm.add()
        this.$refs.modalForm.title = '新增'
        this.$refs.modalForm.disableSubmit = false
      },
    }
  }
</script>

<style lang="less" scoped></style>
